<template>
  <div class="phone-input">
    <vue-phone-number-input
      v-model="phone"
      :no-flags="false"
      :no-example="false"
      :showCodeOnList="true"
      hint=""
      :required="required"
      :default-country-code="default_cc"
      :preferred-countries="countriesList"
      @update="phoneInputUpdate"
      :translations="texts"
    />
    <input type="hidden" v-bind:name="name + '_cc'" v-bind:value="value_cc" />
    <input type="hidden" v-bind:name="name" v-bind:value="value" />
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { AsYouType } from "libphonenumber-js";

export default {
  props: {
    name: "",
    countryCode: "",
    defaultValue: "",
    translations: {},
    required: false,
    defaultCountries: {
      type: [Array, String],
      default: () => ["MD", "RO"],
    },
    countries: {
      type: [Array, String],
      default: () => ["MD", "RO"],
    },
  },

  components: {
    VuePhoneNumberInput,
  },

  computed: {
    // All countries stay selectable; this list is only pinned to the top of the dropdown.
    countriesList() {
      if (this.countries && this.countries.length > 0) {
        return this.countries.split(",").map(c => c.trim().toUpperCase());
      }

      return this.defaultCountries;
    },
  },

  data() {
    return {
      phone: this.defaultValue,
      default_cc: "",
      value: "",
      value_cc: "",
      texts: {
        countrySelectorLabel: "Codul țării",
        countrySelectorError: "Alege o tara",
        phoneNumberLabel: "Numărul de telefon",
        example: "Exemplu :",
        ...this.translations,
      },
    };
  },

  created() {
    const cc = (this.countryCode || this.countriesList[0] || "MD").toUpperCase();
    this.default_cc = cc;
    this.value = this.phone;
    this.value_cc = this.default_cc;
  },

  mounted() {
    console.log("PhoneInput Component Mounted.");
  },

  methods: {
    phoneInputUpdate(data) {
      this.value = data.formatNational;
      this.value_cc = data.countryCode;

      // Typing a number with its international prefix (e.g. "+40 7...")
      // switches the country selector to the matching country.
      const detected = this.detectCountry(data.phoneNumber || this.phone);
      if (detected && detected !== data.countryCode) {
        this.default_cc = detected;
      }
    },

    detectCountry(number) {
      if (!number || !number.trim().startsWith("+")) {
        return null;
      }

      const parser = new AsYouType();
      parser.input(number);

      return parser.getCountry() || (parser.getNumber() && parser.getNumber().country) || null;
    },
  },
};
</script>
<style lang="css">
.phone-input .input-tel .input-tel__input {
  padding: 0 12px;
}
.phone-input .country-selector .country-selector__input {
  padding-bottom: 1px;
}
</style>
